import { Alert, Center, Loader, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';

import { pagesApi } from '../api/studio';
import type { ContentPageSlug } from '../api/types';
import { PageTitle } from '../components/PageTitle';
import { ru } from '../i18n/ru';
import { formatDate } from '../studio/format';

interface ContentPageViewProps {
  slug: ContentPageSlug;
}

/** Показ текстовой страницы: общая информация и правовые документы. */
export function ContentPageView({ slug }: ContentPageViewProps) {
  const page = useQuery({
    queryKey: ['page', slug],
    queryFn: () => pagesApi.get(slug),
    retry: false,
    // Правовые тексты меняются раз в год: перезапрашивать их при каждом
    // переходе незачем.
    staleTime: 10 * 60 * 1000,
  });

  if (page.isPending) {
    return (
      <Center h={200}>
        <Loader />
      </Center>
    );
  }

  if (page.isError || page.data === undefined) {
    return (
      <Alert color="gray" variant="light" maw={560}>
        {ru.pages.notFound}
      </Alert>
    );
  }

  return (
    <Stack gap="lg" maw={800}>
      <PageTitle title={page.data.title} />

      {/* Разметку чистит сервер при сохранении и при первичной загрузке
          текстов — на клиенте она уже безопасна. */}
      <div className="news-body" dangerouslySetInnerHTML={{ __html: page.data.bodyHtml }} />

      <Text size="xs" c="graphite.5">
        {ru.pages.updatedAt}: {formatDate(page.data.updatedAt)}
      </Text>
    </Stack>
  );
}
